import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CASE_MANAGEMENT_CASE_BASE_PATH } from '../../../../../../features/case-management/case-management-routing';
import { CaseInboxLiteList } from '../../../../../../features/case-management/inbox-lite/case-inbox-lite-list';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/inbox/_inbox/')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'clearing-case-management',
        label: 'Inbox',
        to: CASE_MANAGEMENT_CASE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
  component: CaseManagementIndex,
});

function CaseManagementIndex() {
  return (
    <PageLayout gap={7} maxWidthContainer="720px">
      <PageLayout.Section noBorder>
        <CaseInboxLiteList />
      </PageLayout.Section>
    </PageLayout>
  );
}
